<ul class="mvd_navbar__right__list">
    <ng-container *ifLoggedIn="true">
        <li class="mvd_navbar__reload" *ifHasBusinessUnit="true">
            <reload-page></reload-page>
        </li>
    </ng-container>
    <li class="mvd_navbar__user dropdown" dropdown login></li>
    <ng-container *ifLoggedIn="true">
        <li class="mvd_navbar__checkin" *ifHasBusinessUnit="true">
            <a class="icon--checkin mvd_navbar__link" href="javascript:void(0);" title="Check-In" data-bs-toggle="dropdown" role="button" [routerLink]="['..', 'transaction', 'search']" *ifLoggedIn="true"></a>
        </li>
        <li class="mvd_navbar__cart" *ifHasBusinessUnit="true">
            <a cart-icon class="icon--cart mvd_navbar__link" href="javascript:void(0);" title="Cart" data-bs-toggle="dropdown" role="button" *ifLoggedIn="true"><b class="mvd_navbar__count"><cart-count></cart-count></b></a>
        </li>
        <li class="mvd_navbar__notifications">
            <a class="icon--notifications mvd_navbar__link" href="javascript:void(0);" notification-icon title="Notifications" data-bs-toggle="dropdown" role="button" *ifLoggedIn="true"><b class="mvd_navbar__count"><notification-count></notification-count></b></a>
        </li>
        <li class="mvd_navbar__heartbeat">
            <connection-monitor *ifLoggedIn="true"></connection-monitor>
        </li>
        <li [ngClass]="{'mvd_navbar__help':true, 'open': helpVisible}" *ifLoggedIn="true">
            <a class="mvd_navbar__link" href="javascript:void(0)" title="Help" (click)="navHelpIconClicked()"><i class="material-icons">help_outline</i></a>
            <div class="dropdown-menu help--panel">
                <user-assistance-panel></user-assistance-panel>
            </div>
        </li>
    </ng-container>
</ul>